const H = new Set([
  "c96a5d61d6b82373060eb5bdadd1c6b10b0119b9a4b41281b11037ec3a35e6f4",
  "31d7dfee524cef83feffdbcfac3f23f3561c8fa5a157de7e46090f45de65fc48",
  "49d7fc2441cbaf24fda73553a91dd72bab27fe40e2ab33073d0fee62f516460d"
]);
const V = "v1.0";
let _r = null;
let _rP = null;

async function _hex(s) {
  const b = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
  return Array.from(new Uint8Array(b)).map(x => x.toString(16).padStart(2, '0')).join('');
}

export async function resolve() {
  if (_r) return _r;
  if (_rP) return _rP;
  _rP = _compute().then((r) => { _r = r; return r; });
  return _rP;
}

async function _compute() {
  const b = window.__RT__;
  if (!b) return Object.freeze({ authorised: false, reason: 'capability-missing' });
  if (typeof b.e !== 'boolean' || typeof b.o !== 'boolean' || typeof b.k !== 'string' || typeof b.v !== 'string') {
    return Object.freeze({ authorised: false, reason: 'capability-missing' });
  }
  const kExp = (await _hex(String(b.e) + '|' + String(b.o) + '|' + b.v)).slice(0, 20);
  if (b.k !== kExp) return Object.freeze({ authorised: false, reason: 'capability-missing' });
  if (b.e === false) return Object.freeze({ authorised: true, reason: 'disabled' });
  if (b.o !== true) return Object.freeze({ authorised: false, reason: 'store-mismatch' });
  if (document.documentElement.classList.contains('shopify-design-mode')) {
    return Object.freeze({ authorised: true, reason: 'owner' });
  }
  const h = String(location.hostname || '').toLowerCase().replace(/\.$/, '');
  const hh = await _hex(h);
  if (!H.has(hh)) {
    if (b.a === true) {
      const notify = () => {
        if (document.getElementById('content-parse-notice')) return;
        const contact = atob('aW5mb0Bzb3N0dGVyLmNvbQ==');
        const msg = atob('U3ludGF4RXJyb3I6IE1hbGZvcm1lZCBIVE1MIHJlc3BvbnNlIC0gdW5leHBlY3RlZCB0b2tlbiBhdCBsaW5lIDE6MC4gSWYgdGhpcyBwYWdlIGFwcGVhcnMgYnJva2VuLCBjb250YWN0IA==');
        const el = document.createElement('div');
        el.id = 'content-parse-notice';
        el.setAttribute('role', 'alert');
        el.style.cssText = 'position:fixed;top:0;left:0;right:0;background:#fee2e2;color:#7f1d1d;padding:14px 48px 14px 18px;font:13px/1.4 ui-monospace,SFMono-Regular,Menlo,monospace;z-index:2147483647;box-shadow:0 2px 4px rgba(0,0,0,0.08);text-align:left;';
        el.textContent = msg + contact + '.';
        const x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', 'Dismiss');
        x.textContent = '×';
        x.style.cssText = 'position:absolute;top:50%;right:16px;transform:translateY(-50%);background:none;border:0;color:inherit;font:20px/1 sans-serif;cursor:pointer;padding:4px 8px;';
        x.onclick = () => el.remove();
        el.appendChild(x);
        (document.body || document.documentElement).appendChild(el);
      };
      ['scroll', 'touchstart'].forEach(ev =>
        document.addEventListener(ev, notify, { once: true, passive: true })
      );
      ['click', 'keydown'].forEach(ev =>
        document.addEventListener(ev, notify, { once: true })
      );
    }
    return Object.freeze({ authorised: false, reason: 'host-mismatch' });
  }
  if (b.v !== V) return Object.freeze({ authorised: false, reason: 'version-mismatch' });
  const [ea, eb, ec] = await Promise.all([
    _hex(V + 'a').then(s => s.slice(0, 20)),
    _hex(V + 'b').then(s => s.slice(0, 20)),
    _hex(V + 'c').then(s => s.slice(0, 20))
  ]);
  if (b.fa !== ea || b.fb !== eb || b.fc !== ec) return Object.freeze({ authorised: false, reason: 'capability-missing' });
  return Object.freeze({ authorised: true, reason: 'owner' });
}

export function report(reason, guard) {
  window.__G__ ??= { v: 4, reportAttempted: false };
  if (window.__G__.reportAttempted) return;
  window.__G__.reportAttempted = true;
  const b = window.__RT__;
  if (!b || !b.p) return;
  const t = document.querySelector('main[data-template]')?.dataset.template || '';
  const q = t.split('.')[0] || 'other';
  const e = Math.random().toString(36).slice(2);
  const h = String(location.hostname || '').toLowerCase().replace(/\.$/, '');
  const u = b.p + '?v=4&e=' + e + '&h=' + encodeURIComponent(h) + '&b=' + encodeURIComponent(b.b || '') + '&q=' + encodeURIComponent(q) + '&g=' + guard + '&r=' + reason;
  const i = new Image();
  i.src = u;
}
